export const LOADER_STATUS = 'boilderplate/GSTR1NEWCOMMON/LOADER_STATUS';
export const PROFILE_DATA = 'boilerplate/GSTR1NEWCOMMON/PROFILE_DATA';
export const VENDOR_LIST = 'boilerplate/GSTR1NEWCOMMON/VENDOR_LIST';
export const STORE_ENTITY = 'boilerplate/GSTR1NEWCOMMON/STORE_ENTITY';
export const SET_FILING_STATUS = 'boilerplate/GSTR1NEWCOMMON/SET_FILING_STATUS';
export const STORE_GSTIN = 'boilerplate/GSTR1NEWCOMMON/STORE_GSTIN';
export const STORE_PERIOD = 'boilerplate/GSTR1NEWCOMMON/STORE_PERIOD';
export const STORE_DROPDOWN_GSTIN = 'boilerplate/GSTR1NEWCOMMON/STORE_DROPDOWN_GSTIN';
export const SET_ENTITY_LIST = 'boilderplate/GSTR1NEWCOMMON/SET_ENTITY_LIST';
export const DEFAULT_ENTITY = 'boilderplate/GSTR1NEWCOMMON/DEFAULT_ENTITY';
export const STORE_GSTIN_GSTR1NEW = 'boilderplate/GSTR1NEWCOMMON/STORE_GSTIN_GSTR1NEW';
export const STORE_PERIOD_SINGLE = 'boilerplate/GSTR1NEWCOMMON/STORE_PERIOD_SINGLE';

